import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import GridLoading from '../Loaders/GridLoading';
import { process } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { parseDate } from '@telerik/kendo-intl';
import EntityPopup from "./components/EntityPopup";
import CustomEntityPopup from "./components/CustomEntityPopup";

class DemographicsList extends Component {

  constructor(props) {
    super(props);

    this.minGridWidth = 0;



    var columns = [{ field: 'EntityCode', title: 'Entity Code', headerClass: 'gridHeader', minWidth: 150 },
    { field: 'Name1', title: 'Name 1', headerClass: 'gridHeader', minWidth: 150 },
    { field: 'Name2', title: 'Name 2', headerClass: 'gridHeader', minWidth: 150 },
    { field: 'Name3', title: 'Name 3', headerClass: 'gridHeader', minWidth: 150 },
    { field: 'EntityType', title: 'Entity Type', headerClass: 'gridHeader', width: 150 },
    { field: 'EntityStartDate', title: 'Entity Start Date', filter: 'text', format: '{0:d}', headerClass: 'gridHeader', width: 200 },
    { field: 'EntityCloseDate', title: 'Entity Close Date', filter: 'text', format: '{0:d}', headerClass: 'gridHeader', width: 200 },
    { field: 'CustodianAccountNumber', title: 'Custodian Account Number', headerClass: 'gridHeader', width: 225 },
    ]


    this.state = {
      users: [],
      roles: [],
      result: [],
      refreshText: '',
      filterable: false,
      groups: false,
      logs: false,
      columns: columns,
      dataState: { skip: 0, take: 25, sort: [{ field: 'EntityType', dir: 'desc' }, { field: 'EntityCode', dir: 'asc' }] },
      enableMFA: null,
      templates: [],
      tempDefault: { title: 'Default Template' },
      RIAFirmName: '',
      demographicsExport: [],
      exportColumns: [],
      demographicsCustomExport: [],
      exportColumnsCustom: [],
      // advAllUsers: false
    }

    this.createCell = this.createCell.bind(this);
    this.sendResetLink = this.sendResetLink.bind(this);
    this.expandChange = this.expandChange.bind(this);
    this.changeActivate = this.changeActivate.bind(this);
    this.changeUserData = this.changeUserData.bind(this);
    this.getDemographics = this.getDemographics.bind(this);
    this.getDate = this.getDate.bind(this);
    this.getSuperAdminSettings = this.getSuperAdminSettings.bind(this);

  }

  componentDidMount() {
    this.getSuperAdminSettings();
    this.getStyleSettings()
    this.getDemographics()
  }

  componentDidUpdate() {

  }

  getStyleSettings = (cb) => {
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var styleNames = ['requireTermsAndConditions,RIAFirmName,showFilters']

    axios(`api/getStyleSettings`, {
      method: 'GET',
      params: { company: this.props.user.company, styleNames: styleNames },
      headers: headers
    })
      .then(response => {
        this.setState((prevState) => {
          let obj = {
            ...prevState,
            requireTermsAndConditions: response.data.styleSettings.requireTermsAndConditions,
            filterable: response.data.styleSettings.showFilters,
            RIAFirmName: response.data.styleSettings.RIAFirmName
          };
          return obj;
        }, () => { if (cb) cb() })
      })
      .catch(err => {
        console.error(err);
        if (cb) cb()
      })
  }

  getSuperAdminSettings() {
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    axios(`api/superAdminSettings`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers
    })
      .then(response => {
        response.data.data.forEach(setting => {
          if (setting.settingName === 'enableMFA') {
            this.setState({ enableMFA: setting.settingValue.toLowerCase() === 'true' ? true : false })
          }
        })

      })
      .catch(err => console.log(err));
  }


  getDemographics(cb) {
    this.setState({ refreshText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var demographics = [];



    axios(`api/demographicsList`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        console.log(response)
        demographics = this.formatDemographicsList(response.data.data);
        var result = process(demographics, this.state.dataState)
        this.setState({ demographics: demographics, result: result, refreshText: '' })

      })
      .catch(err => {
        console.error(err);
      })
  }


  refreshProfileCreationDates(cb) {
    this.setState({ refreshText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    var isAdvisor = this.props.user.role === 'advisor' /*&& !this.state.advAllUsers*/;

    // axios.get("api/test?company="+this.props.company,{headers});

    axios.get("api/updateUserProfileCreationDates?company=" + this.props.company + "&advisor=" + isAdvisor + "&userlevel=" + this.props.user.userLevel, { headers }).then(response => {
      if (response.data.code === 200) {
        this.getDemographics(cb);
      }
      else {
        if (cb)
          cb();
        this.setState({ refreshText: '' });
        alert("An error occured while refreshing the user profile creation dates.");

      }
    }).catch(error => console.log(error));
  }

  formatDemographicsList(demographics) {
    for (let i = 0; i < demographics.length; i++) {

      demographics[i].EntityCloseDate = demographics[i].EntityCloseDate ? this.formatDate(demographics[i].EntityCloseDate) : null;
      demographics[i].EntityStartDate = demographics[i].EntityStartDate ? this.formatDate(demographics[i].EntityStartDate) : null;

    }

    return demographics;
  }

  formatDate(date) {
          var d;
  
          if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
          else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }
  
          const day = String(d.getUTCDate()).padStart(2, '0');
          const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
          const year = d.getUTCFullYear();
  
          return `${month}/${day}/${year}`;
  
      }

  getDate(sqlDate) {
    var d = parseDate(sqlDate, "yyyy-MM-ddTHH:mm:ss.SSSXXX");
    var utc = null;

    if (d !== null)
      utc = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

    return utc;
  }

  sendResetLink(userID, email, role, nickname) {
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
    var payload = {
      userId: userID,
      to: email,
      uploadUser: this.props.user,
      company: this.props.user.company,
      role: role,
      nickname: nickname,
      RIAFirmName: this.state.RIAFirmName
    }
    axios.post("api/verifyEmail", payload, { headers }).then(response => {
      if (response.status === 200)
        alert("Verification email has been sent.");
      else {
        alert("There was an error sending the verification email. Please try again.");
      }
    }).catch(error => console.log(error));
  }

  createCell(cell) {
    return (
      <td>
        <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getDemographics} entity={cell.dataItem.EntityCode} button={<Button>Edit</Button>} />
        <CustomEntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getDemographics} entity={cell.dataItem.EntityCode} button={<Button>Edit Custom</Button>} />
      </td>
    );
  }

  changeActivate(email, active) {
    var arr = this.state.users.slice();

    var indexOfUser = arr.findIndex((item) => {
      return item.email === email;
    });

    arr[indexOfUser].active = active;
    this.setState({ users: arr });
  }

  changeUserData(email, newRole, newViews, approved) {
    var arr = this.state.users.slice();

    var indexOfUser = arr.findIndex(function (item) {
      return item.email === email
    });

    if (indexOfUser !== -1) {
      arr[indexOfUser].role = newRole;
      arr[indexOfUser].access = newViews;
      arr[indexOfUser].approved = approved;
    }
    this.setState({ users: arr });
  }

  expandChange = (event) => {
    const data = this.state.result.data.map(item =>
      item.id === event.dataItem.id
        ? {
          ...item,
          expanded: !item.expanded,
          enableMFA: this.state.enableMFA,
          templates: this.state.templates,
          tempDefault: this.state.tempDefault
        }
        : item
    );
    this.setState((prevState) => {
      let obj = { ...prevState };
      obj.result.data = data;
      return obj;
    })
  };

  _export;
  _export2;

  export = () => {
    this.setState({ exportLoadingText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };



    axios(`api/demographicsAll`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        // var folder
        var exportColumns = []
        var format = ''
        var key = null
        for (let i = 0; i < response.data.data.length; i++) {
          for (let j = 0; j < Object.keys(response.data.data[i]).length; j++) {
            key = Object.keys(response.data.data[i])[j]
            format = ''
            // if (key.toLocaleLowerCase().includes('date')) {
            //   format = 'mm/md/yyyy'
            //   response.data.data[i][key] = this.getDate(response.data.data[i][key])
            // }
            if (i === 0 && (key.toLowerCase() !== 'date')) { exportColumns.push({ field: key, format: format }) }
          }
        }

        this.setState({ demographicsExport: this.getFullFilteredList(response.data.data), exportColumns: exportColumns }, () => {
          this._export.save();
        })
      })
      .catch(err => {
        console.error(err);
      })

  }

  export2 = () => {
    this.setState({ customExportLoadingText: 'Loading...' });

    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };



    axios(`api/demographicsCustomAll`, {
      method: 'GET',
      params: { company: this.props.user.company },
      headers: headers,
    })
      .then(response => {
        // var folder
        var exportColumns = [{ field: 'EntityCode', title: 'Entity Code', minWidth: 150 },
        { field: 'Label', title: 'Label', headerClass: 'gridHeader', minWidth: 150 },
        { field: 'LabelValue', title: 'LabelValue', headerClass: 'gridHeader', minWidth: 150 },
        // { field: 'Date', title: 'Date', headerClass: 'gridHeader', format: 'm/d/yyyy h:mm AM/PM', minWidth: 150 },
        ]
        this.setState({ demographicsCustomExport: this.getFullFilteredList(response.data.data), exportColumnsCustom: exportColumns }, () => {
          this._export2.save();
        })
      })
      .catch(err => {
        console.error(err);
      })

  }

  getFullFilteredList(list) {//for excel export, otherwise only the amount of users on a single page would be exported
    let noSkipDataState = { ...this.state.dataState }

    noSkipDataState.skip = null
    noSkipDataState.take = null

    return process(list, noSkipDataState).data;
    //return process(this.state.users, noSkipDataState);
  }

  changeDataState = (e) => {
    var data = { ...e.dataState }
    if (data.filter != null && data.filter.filters != null) {
      data.filter.filters.forEach(item => {
      })
      // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
    }
    var newData = process(this.state.demographics, data);
    this.setState({ dataState: data, result: newData });
  }

  render() {
    return (
      <div>
        {!this.state.groups && !this.state.logs && (
          <div className="demographicsList">
            <ExcelExport data={this.state.demographicsExport} onExportComplete={() => { this.setState({ exportLoadingText: '' }) }} fileName='Demographics_Export.xlsx' ref={(exporter) => { this._export = exporter; }}>
              {this.state.exportColumns.map((column, key) => {
                return <ExcelExportColumn field={column.field} cellOptions={{ format: column.format }} title={column.field} key={key} />
              })}
            </ExcelExport>
            <ExcelExport data={this.state.demographicsCustomExport} onExportComplete={() => { this.setState({ customExportLoadingText: '' }) }} fileName='Demographics_Custom_Export.xlsx' ref={(exporter) => { this._export2 = exporter; }}>
              {this.state.exportColumnsCustom.map((column, key) => {
                return <ExcelExportColumn field={column.field} title={column.title} cellOptions={{ format: column.format }} key={key} />
              })}
            </ExcelExport>
            <Grid data={this.state.result}
              resizable={true}
              reorderable={true}
              pageable={{ pageSizes: [10, 25, 50, 100, 250, 500] }}
              sortable={{ mode: 'multiple' }}
              onDataStateChange={this.changeDataState}
              filterable={this.state.filterable}
              {...this.state.dataState}>
              <GridNoRecords>
                {this.state.refreshText && ''}
                {!this.state.refreshText && 'No records available'}
              </GridNoRecords>
              <GridToolbar>
                <Button icon='refresh' title='Refresh' onClick={(e) => this.getDemographics()}>{this.state.refreshText}</Button>
                <EntityPopup idToken={this.props.idToken} user={this.props.user} refresh={this.getDemographics} create={true} entity={''} button={<Button icon="plus" title='New'>Add New</Button>} />
                <Button icon="excel" title='Export to Excel' disabled={this.state.exportLoadingText} onClick={this.export}>{this.state.exportLoadingText || 'Export'}</Button>
                <Button icon="excel" title='Export Custom to Excel' disabled={this.state.customExportLoadingText} onClick={this.export2}>{this.state.customExportLoadingText || 'Export Custom'}</Button>
                <Button icon="upload" title='Import' onClick={() => { }}>Import</Button>
              </GridToolbar>
              {
                this.state.columns.map((column, key) => {
                  return <GridColumn field={column.field} title={column.title} key={key} format={column.format} cell={column.cell} filterable={column.filterable} filterCell={column.filterCell} filter={column.filter} headerClassName={column.headerClass} width={column.width} />
                })
              }
              <GridColumn
                field='editDelete' 
                headerClass='gridHeader' 
                filterable={false}
                title=" "
                width="175px"
                cells={{
                  data: (props) => this.createCell(props)
                }}
              />
            </Grid>
            {this.state.refreshText && <GridLoading gridClass='userList' />}
          </div>)
        }
      </div>
    );
  }

}

export default DemographicsList;